module.exports = __webpack_public_path__ + "static/media/service--desktop.3a9e6ee0.png";